<template>
  <div ref="chart" class="chart" :style="{ height: height, ...chartStyle }">饼图</div>
</template>

<script>
import { echartBaseMixin } from '../mixins'

export default {
  name: 'PieChart',
  mixins: [echartBaseMixin], // 混合
  props: {
    type: {
      type: String,
      default: 'radar',
    },
    indicator: {
      type: Array,
      default: () => [],
    },
    radius: {
      type: [String, Array],
      default: '60%',
    },
    label: {
      type: Object,
      default: () => ({
        // show: true,
        // position: 'center',
        // formatter: function () {
        //   return '{customStyle|自定义文字}'
        // },
        // rich: {
        //   customStyle: {
        //     color: '#000',
        //     fontSize: 20,
        //     fontWeight: 'bold',
        //   },
        // },
      }),
    },
    graphic: {
      type: [Object, Array],
      default: () => [
        {
          type: 'text',
          left: 'center',
          top: '37%',
          style: {
            text: '',
            textAlign: 'center',
            fontSize: 28,
            fontWeight: 'bold',
            fill: '#333',
          },
        },
        {
          type: 'text',
          left: 'center',
          top: '50%',
          style: {
            text: '',
            textAlign: 'center',
            fontSize: 15,
            fontWeight: 'normal',
            fill: '#666',
          },
        },
      ],
    },
    pieText: {
      type: [String, Array],
      default: () => ['0', '总数'],
    },
  },
  data() {
    return {
      options: {
        // title: {
        //   text: 'Referer of a Website',
        //   subtext: 'Fake Data',
        // left: 'center',
        // },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          left: 'left', // 图例的位置
          top: 'middle', // 图例的位置
        },
        grid: {},
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '60%',
            center: ['50%', '45%'],
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
              { value: 300, name: 'Video Ads' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      },
    }
  },
  created() {
    this.setLegend()
    this.initPieOptions()
    // console.log('选项options', this.options)
  },
  watch: {
    dataSource: {
      handler() {
        this.initPieOptions()
        this.setLegend()
        this.renderChart()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initPieOptions() {
      if (!this.dataSource.length) return
      this.$set(this.options.series[0], 'data', this.dataSource)
      this.$set(this.options.series[0], 'radius', this.radius)
      this.$set(this.options, 'grid', this.grid)
      this.$set(this.options.series[0], 'label', this.label)
      this.graphic.forEach((item, index) => {
        item.style = {
          ...item.style,
          text: this.pieText[index],
        }
      })
      this.$set(this.options, 'graphic', this.graphic)
      if (this.color?.length) {
        this.$set(this.options, 'color', this.color)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.chart {
  width: 100%;
}
</style>
